//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export const SUMMARY_REFERRALS_VALUES = {
  REVENUE: 'revenue',
  TRAFFIC: 'traffic',
};

export const SUMMARY_REFERRALS_VALUE_LABELS = {
  [SUMMARY_REFERRALS_VALUES.REVENUE]: 'Revenue',
  [SUMMARY_REFERRALS_VALUES.TRAFFIC]: 'Traffic',
};

export const SUMMARY_REFERRALS_LABELS = {
  LIKE2BUY: 'Like2Buy',
  STORIES: 'Story Links',
  PROMOTED_POSTS: 'Promoted Posts',
  SHOP_TAGS: 'Shop Tags',
};

export const SUMMARY_REFERRALS_COLORS = {
  LIKE2BUY: '#47C1D7',
  STORIES: '#D2F0F6',
  PROMOTED_POSTS: '#95E1E6',
  SHOP_TAGS: '#5D93E6',
};
